import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebouncedCallback } from 'use-debounce';
import { useInfinitePlayersOptionsQuery } from './Teams.state';
import { FormAutocompleteMultiple } from "../common/FormAutocomplete";

const TeamSelect = ({
  setValue,
  value,
  mapLabel = "email",
  placeholder,
  readOnly = false,
  loading = false,
}) => {
  const { t } = useTranslation();
  const [term, setTerm] = useState('');
  const onRemoteSearch = useDebouncedCallback((query) => {
    setTerm(query);
  }, 600);

  const { players: options, fetchNextPage, isFetching, hasNextPage } =
    useInfinitePlayersOptionsQuery({ term });

  const normalizedValue = useMemo(() => value || [], [value]);
  const displayOptions = useMemo(
    () => (readOnly ? normalizedValue : options),
    [normalizedValue, options, readOnly]
  );

  const onNextPage = useCallback(async () => {
    if (isFetching || !hasNextPage) {
      return;
    }
    await fetchNextPage();
  }, [isFetching, hasNextPage, fetchNextPage]);

  return (
    <FormAutocompleteMultiple
      loading={isFetching || loading}
      options={displayOptions}
      mapLabel={mapLabel}
      disableClearable={true}
      size="small"
      placeholder={placeholder || t("Select people...")}
      onChange={(e, value) => {
        setValue(value);
      }}
      value={value}
      onRemoteSearch={readOnly ? undefined : onRemoteSearch}
      onNextPage={readOnly ? undefined : onNextPage}
      stateful={false}
      forcePopupIcon={!readOnly}
      disableCloseOnSelect={readOnly}
      filterSelectedOptions={!readOnly}
    />
  );
};

export default TeamSelect; 